module.exports = __webpack_public_path__ + "static/media/female-avatar.ea691d51.png";